import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from './ui/label';

/** Cuenta que el 🔔 le pide a los clubes de una cartera. Vacío = la cuenta general del CRM. */
export const CarteraCuentaCobro = ({ value, onChange, abierto }) => {
  const [cuentas, setCuentas] = useState([]);

  useEffect(() => {
    if (!abierto) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/bancos`)
      .then(res => setCuentas((res.data || []).filter(c => c.status === 'active' && c.alias)))
      .catch(() => setCuentas([]));
  }, [abierto]);

  return (
    <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4 space-y-2">
      <Label htmlFor="cartera-cuenta-cobro">Cuenta de cobro (campanita)</Label>
      <select
        id="cartera-cuenta-cobro"
        data-testid="cartera-cuenta-cobro-select"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800"
      >
        <option value="">Usar la cuenta general del CRM</option>
        {cuentas.map((c) => (
          <option key={c.alias} value={c.alias}>
            {c.alias} · {c.cbu_cvu}{c.titular ? ` · ${c.titular}` : ''}
          </option>
        ))}
      </select>
      <p className="text-xs text-gray-500">
        ℹ️ Es la cuenta que el 🔔 le pide a los clubes de esta cartera cuando tienen saldo en contra.
        No afecta la validación de comprobantes (esa usa el CBU Destino de arriba).
      </p>
    </div>
  );
};

export default CarteraCuentaCobro;
